const programNames = [
  {
    id: 1,
    heading: "C++ Programs",
    slug: "cpp",
    data: [
      {
        id: 111,
        name: "Sum of all numbers using loop",
        slug: "sum-of-all-numbers-using-loop-cpp",
        language: "cpp",
        code: `
        // C++ program to find sum of first 
        // n natural numbers using loop. 
        #include <iostream> 
        using namespace std; 
        
        // Returns sum of first n natural 
        // numbers 
        int findSum(int n) 
        { 
            int sum = 0; 
            for (int i = 1; i <= n; i++) 
                sum = sum + i; 
            return sum; 
        } 
        
        // Driver code 
        int main() 
        { 
            int n = 5; 
            cout << findSum(n); 
            return 0; 
        }`,
      },
      {
        id: 112,
        name: "Factorial of a number",
        slug: "factorial-of-a-number-cpp",
        language: "cpp",
        code: `
          // C++ program to calculate factorial of a number
          #include <iostream>
          using namespace std;

          int factorial(int n) {
              if (n == 0)
                  return 1;
              else
                  return n * factorial(n - 1);
          }

          int main() {
              int n = 5;
              cout << "Factorial of " << n << " is " << factorial(n);
              return 0;
          }`,
      },
      {
        id: 113,
        name: "Fibonacci series",
        slug: "fibonacci-series-cpp",
        language: "cpp",
        code: `
          // C++ program to print Fibonacci series
          #include <iostream>
          using namespace std;

          void fibonacci(int n) {
              int a = 0, b = 1;
              cout << "Fibonacci Series: ";
              for (int i = 1; i <= n; ++i) {
                  cout << a << " ";
                  int next = a + b;
                  a = b;
                  b = next;
              }
          }

          int main() {
              int n = 10;
              fibonacci(n);
              return 0;
          }`,
      },
      {
        id: 114,
        name: "Reverse a number",
        slug: "reverse-a-number-cpp",
        language: "cpp",
        code: `
          // C++ program to reverse a number
          #include <iostream>
          using namespace std;

          int reverseNumber(int n) {
              int reversed = 0;
              while (n != 0) {
                  int digit = n % 10;
                  reversed = reversed * 10 + digit;
                  n /= 10;
              }
              return reversed;
          }

          int main() {
              int num = 12345;
              cout << "Reversed number: " << reverseNumber(num);
              return 0;
          }`,
      },
      {
        id: 115,
        name: "Check if a number is prime",
        slug: "check-if-a-number-is-prime-cpp",
        language: "cpp",
        code: `
          // C++ program to check if a number is prime
          #include <iostream>
          using namespace std;

          bool isPrime(int n) {
              if (n <= 1) return false;
              for (int i = 2; i * i <= n; ++i) {
                  if (n % i == 0) return false;
              }
              return true;
          }

          int main() {
              int num = 29;
              if (isPrime(num))
                  cout << num << " is a prime number.";
              else
                  cout << num << " is not a prime number.";
              return 0;
          }`,
      },
      {
        id: 116,
        name: "Palindrome check",
        slug: "palindrome-check-cpp",
        language: "cpp",
        code: `
          // C++ program to check if a number is palindrome
          #include <iostream>
          using namespace std;

          bool isPalindrome(int n) {
              int reversed = 0, original = n;
              while (n != 0) {
                  int digit = n % 10;
                  reversed = reversed * 10 + digit;
                  n /= 10;
              }
              return original == reversed;
          }

          int main() {
              int num = 12321;
              if (isPalindrome(num))
                  cout << num << " is a palindrome.";
              else
                  cout << num << " is not a palindrome.";
              return 0;
          }`,
      },
      {
        id: 117,
        name: "Calculate area of a circle",
        slug: "calculate-area-of-a-circle-cpp",
        language: "cpp",
        code: `
          // C++ program to calculate area of a circle
          #include <iostream>
          using namespace std;

          const float PI = 3.14159;

          float calculateArea(float radius) {
              return PI * radius * radius;
          }

          int main() {
              float radius = 5.0;
              cout << "Area of circle with radius " << radius << " is: " << calculateArea(radius);
              return 0;
          }`,
      },
      {
        id: 118,
        name: "Simple interest calculation",
        slug: "simple-interest-calculation-cpp",
        language: "cpp",
        code: `
          // C++ program to calculate simple interest
          #include <iostream>
          using namespace std;

          float calculateSimpleInterest(float principal, float rate, int time) {
              return (principal * rate * time) / 100;
          }

          int main() {
              float principal = 1000.0;
              float rate = 5.0;
              int time = 2;
              cout << "Simple interest: " << calculateSimpleInterest(principal, rate, time);
              return 0;
          }`,
      },
      {
        id: 119,
        name: "Check if a year is leap year",
        slug: "check-if-a-year-is-leap-year-cpp",
        language: "cpp",
        code: `
          // C++ program to check if a year is leap year
          #include <iostream>
          using namespace std;

          bool isLeapYear(int year) {
              if (year % 4 == 0) {
                  if (year % 100 != 0 || year % 400 == 0)
                      return true;
              }
              return false;
          }

          int main() {
              int year = 2024;
              if (isLeapYear(year))
                  cout << year << " is a leap year.";
              else
                  cout << year << " is not a leap year.";
              return 0;
          }`,
      },
      {
        id: 120,
        name: "Convert temperature from Celsius to Fahrenheit",
        slug: "convert-temperature-from-celsius-to-fahrenheit-cpp",
        language: "cpp",
        code: `
          // C++ program to convert temperature from Celsius to Fahrenheit
          #include <iostream>
          using namespace std;

          float celsiusToFahrenheit(float celsius) {
              return (celsius * 9 / 5) + 32;
          }

          int main() {
              float celsius = 25.0;
              cout << celsius << " Celsius is equal to " << celsiusToFahrenheit(celsius) << " Fahrenheit.";
              return 0;
          }`,
      },
    ],
  },
  {
    id: 2,
    heading: "Java Programs",
    slug: "java",
    data: [
      {
        id: 111,
        name: "Sum of all numbers using loop",
        slug: "sum-of-all-numbers-using-loop-java",
        language: "java",
        code: `
        // Java program to find sum of first 
        // n natural numbers using loop. 
        public class Main {
            public static void main(String[] args) {
                int n = 5, sum = 0;
                for (int i = 1; i <= n; ++i) {
                    sum += i;
                }
                System.out.println("Sum = " + sum);
            }
        }`,
      },
      {
        id: 112,
        name: "Factorial of a number",
        slug: "factorial-of-a-number-java",
        language: "java",
        code: `
        // Java program to calculate factorial of a number
        public class Main {
            static int factorial(int n) {
                if (n == 0)
                    return 1;
                else
                    return (n * factorial(n - 1));
            }
        
            public static void main(String[] args) {
                int n = 5;
                System.out.println("Factorial of " + n + " is " + factorial(n));
            }
        }`,
      },
      {
        id: 113,
        name: "Fibonacci series",
        slug: "fibonacci-series-java",
        language: "java",
        code: `
        // Java program to print Fibonacci series
        public class Main {
            public static void main(String[] args) {
                int n = 10, a = 0, b = 1;
                System.out.print("Fibonacci Series: ");
                for (int i = 1; i <= n; ++i) {
                    System.out.print(a + " ");
                    int next = a + b;
                    a = b;
                    b = next;
                }
            }
        }`,
      },
      {
        id: 114,
        name: "Reverse a number",
        slug: "reverse-a-number-java",
        language: "java",
        code: `
        // Java program to reverse a number
        public class Main {
            public static void main(String[] args) {
                int num = 12345;
                int reversed = 0;
                while (num != 0) {
                    int digit = num % 10;
                    reversed = reversed * 10 + digit;
                    num /= 10;
                }
                System.out.println("Reversed number: " + reversed);
            }
        }`,
      },
      {
        id: 115,
        name: "Check if a number is prime",
        slug: "check-if-a-number-is-prime-java",
        language: "java",
        code: `
        // Java program to check if a number is prime
        public class Main {
            public static void main(String[] args) {
                int num = 29;
                boolean isPrime = true;
                if (num <= 1) {
                    isPrime = false;
                } else {
                    for (int i = 2; i <= Math.sqrt(num); i++) {
                        if (num % i == 0) {
                            isPrime = false;
                            break;
                        }
                    }
                }
                if (isPrime)
                    System.out.println(num + " is a prime number.");
                else
                    System.out.println(num + " is not a prime number.");
            }
        }`,
      },
      {
        id: 116,
        name: "Palindrome check",
        slug: "palindrome-check-java",
        language: "java",
        code: `
        // Java program to check if a number is palindrome
        public class Main {
            public static void main(String[] args) {
                int num = 12321;
                int originalNum = num;
                int reversed = 0;
                while (num != 0) {
                    int digit = num % 10;
                    reversed = reversed * 10 + digit;
                    num /= 10;
                }
                if (originalNum == reversed)
                    System.out.println(originalNum + " is a palindrome.");
                else
                    System.out.println(originalNum + " is not a palindrome.");
            }
        }`,
      },
      {
        id: 117,
        name: "Calculate area of a circle",
        slug: "calculate-area-of-a-circle-java",
        language: "java",
        code: `
        // Java program to calculate area of a circle
        public class Main {
            public static void main(String[] args) {
                double radius = 5.0;
                double area = Math.PI * radius * radius;
                System.out.println("Area of circle with radius " + radius + " is: " + area);
            }
        }`,
      },
      {
        id: 118,
        name: "Simple interest calculation",
        slug: "simple-interest-calculation-java",
        language: "java",
        code: `
        // Java program to calculate simple interest
        public class Main {
            public static void main(String[] args) {
                float principal = 1000.0f;
                float rate = 5.0f;
                int time = 2;
                float simpleInterest = (principal * rate * time) / 100;
                System.out.println("Simple interest: " + simpleInterest);
            }
        }`,
      },
      {
        id: 119,
        name: "Check if a year is leap year",
        slug: "check-if-a-year-is-leap-year-java",
        language: "java",
        code: `
        // Java program to check if a year is leap year
        public class Main {
            public static void main(String[] args) {
                int year = 2024;
                boolean isLeapYear = false;
                if (year % 4 == 0) {
                    if (year % 100 != 0 || year % 400 == 0)
                        isLeapYear = true;
                }
                if (isLeapYear)
                    System.out.println(year + " is a leap year.");
                else
                    System.out.println(year + " is not a leap year.");
            }
        }`,
      },
      {
        id: 120,
        name: "Convert temperature from Celsius to Fahrenheit",
        slug: "convert-temperature-from-celsius-to-fahrenheit-java",
        language: "java",
        code: `
        // Java program to convert temperature from Celsius to Fahrenheit
        public class Main {
            public static void main(String[] args) {
                float celsius = 25.0f;
                float fahrenheit = (celsius * 9 / 5) + 32;
                System.out.println(celsius + " Celsius is equal to " + fahrenheit + " Fahrenheit.");
            }
        }`,
      },
    ],
  },
  {
    id: 3,
    heading: "C Programs",
    slug: "c",
    data: [
      {
        id: 111,
        name: "Sum of all numbers using loop",
        slug: "sum-of-all-numbers-using-loop-c",
        language: "c",
        code: '// C program to find sum of first \n// n natural numbers using loop. \n#include <stdio.h>\n\nint main() {\n    int n = 5, sum = 0;\n    for (int i = 1; i <= n; ++i) {\n        sum += i;\n    }\n    printf("Sum = %d\\n", sum);\n    return 0;\n}',
      },
      {
        id: 112,
        name: "Factorial of a number",
        slug: "factorial-of-a-number-c",
        language: "c",
        code: '// C program to calculate factorial of a number\n#include <stdio.h>\n\nint factorial(int n) {\n    if (n == 0)\n        return 1;\n    else\n        return (n * factorial(n - 1));\n}\n\nint main() {\n    int n = 5;\n    printf("Factorial of %d is %d\\n", n, factorial(n));\n    return 0;\n}',
      },
      {
        id: 113,
        name: "Fibonacci series",
        slug: "fibonacci-series-c",
        language: "c",
        code: '// C program to print Fibonacci series\n#include <stdio.h>\n\nint main() {\n    int n = 10, a = 0, b = 1;\n    printf("Fibonacci Series: ");\n    for (int i = 1; i <= n; ++i) {\n        printf("%d ", a);\n        int next = a + b;\n        a = b;\n        b = next;\n    }\n    return 0;\n}',
      },
      {
        id: 114,
        name: "Reverse a number",
        slug: "reverse-a-number-c",
        language: "c",
        code: '// C program to reverse a number\n#include <stdio.h>\n\nint main() {\n    int num = 12345;\n    int reversed = 0;\n    while (num != 0) {\n        int digit = num % 10;\n        reversed = reversed * 10 + digit;\n        num /= 10;\n    }\n    printf("Reversed number: %d\\n", reversed);\n    return 0;\n}',
      },
      {
        id: 115,
        name: "Check if a number is prime",
        slug: "check-if-a-number-is-prime-c",
        language: "c",
        code: '// C program to check if a number is prime\n#include <stdio.h>\n#include <stdbool.h>\n#include <math.h>\n\nint main() {\n    int num = 29;\n    bool isPrime = true;\n    if (num <= 1) {\n        isPrime = false;\n    } else {\n        for (int i = 2; i <= sqrt(num); i++) {\n            if (num % i == 0) {\n                isPrime = false;\n                break;\n            }\n        }\n    }\n    if (isPrime)\n        printf("%d is a prime number.\\n", num);\n    else\n        printf("%d is not a prime number.\\n", num);\n    return 0;\n}',
      },
      {
        id: 116,
        name: "Palindrome check",
        slug: "palindrome-check-c",
        language: "c",
        code: '// C program to check if a number is palindrome\n#include <stdio.h>\n\nint main() {\n    int num = 12321;\n    int originalNum = num;\n    int reversed = 0;\n    while (num != 0) {\n        int digit = num % 10;\n        reversed = reversed * 10 + digit;\n        num /= 10;\n    }\n    if (originalNum == reversed)\n        printf("%d is a palindrome.\\n", originalNum);\n    else\n        printf("%d is not a palindrome.\\n", originalNum);\n    return 0;\n}',
      },
      {
        id: 117,
        name: "Calculate area of a circle",
        slug: "calculate-area-of-a-circle-c",
        language: "c",
        code: '// C program to calculate area of a circle\n#include <stdio.h>\n#include <math.h>\n\nint main() {\n    double radius = 5.0;\n    double area = M_PI * radius * radius;\n    printf("Area of circle with radius %f is: %f\\n", radius, area);\n    return 0;\n}',
      },
      {
        id: 118,
        name: "Simple interest calculation",
        slug: "simple-interest-calculation-c",
        language: "c",
        code: '// C program to calculate simple interest\n#include <stdio.h>\n\nint main() {\n    float principal = 1000.0f;\n    float rate = 5.0f;\n    int time = 2;\n    float simpleInterest = (principal * rate * time) / 100;\n    printf("Simple interest: %f\\n", simpleInterest);\n    return 0;\n}',
      },
      {
        id: 119,
        name: "Check if a year is leap year",
        slug: "check-if-a-year-is-leap-year-c",
        language: "c",
        code: '// C program to check if a year is leap year\n#include <stdio.h>\n#include <stdbool.h>\n\nint main() {\n    int year = 2024;\n    bool isLeapYear = false;\n    if (year % 4 == 0) {\n        if (year % 100 != 0 || year % 400 == 0)\n            isLeapYear = true;\n    }\n    if (isLeapYear)\n        printf("%d is a leap year.\\n", year);\n    else\n        printf("%d is not a leap year.\\n", year);\n    return 0;\n}',
      },
      {
        id: 120,
        name: "Convert temperature from Celsius to Fahrenheit",
        slug: "convert-temperature-from-celsius-to-fahrenheit-c",
        language: "c",
        code: '// C program to convert temperature from Celsius to Fahrenheit\n#include <stdio.h>\n\nint main() {\n    float celsius = 25.0f;\n    float fahrenheit = (celsius * 9 / 5) + 32;\n    printf("%f Celsius is equal to %f Fahrenheit.\\n", celsius, fahrenheit);\n    return 0;\n}',
      },
    ],
  },
  {
    id: 4,
    heading: "DSA",
    slug: "dsa",
    data: [
      {
        id: 111,
        name: "Stack Implementation",
        slug: "stack-implementation-cpp",
        language: "cpp",
        code: '// C++ program for Stack implementation\n#include <iostream>\nusing namespace std;\n#define MAX 1000\n\nclass Stack {\n    int top;\n\npublic:\n    int a[MAX]; // Maximum size of Stack\n\n    Stack() { top = -1; }\n    bool push(int x);\n    int pop();\n    int peek();\n    bool isEmpty();\n};\n\nbool Stack::push(int x) {\n    if (top >= (MAX - 1)) {\n        cout << "Stack Overflow";\n        return false;\n    } else {\n        a[++top] = x;\n        cout << x << " pushed into stack\\n";\n        return true;\n    }\n}\n\nint Stack::pop() {\n    if (top < 0) {\n        cout << "Stack Underflow";\n        return 0;\n    } else {\n        int x = a[top--];\n        return x;\n    }\n}\n\nint Stack::peek() {\n    if (top < 0) {\n        cout << "Stack is Empty";\n        return 0;\n    } else {\n        int x = a[top];\n        return x;\n    }\n}\n\nbool Stack::isEmpty() {\n    return (top < 0);\n}\n\nint main() {\n    class Stack s;\n    s.push(10);\n    s.push(20);\n    s.push(30);\n    cout << s.pop() << " Popped from stack\\n";\n    return 0;\n}',
      },
      {
        id: 112,
        name: "Bubble Sort",
        slug: "bubble-sort-cpp",
        language: "cpp",
        code: '// C++ program for Bubble Sort\n#include <iostream>\nusing namespace std;\n\nvoid bubbleSort(int arr[], int n) {\n    for (int i = 0; i < n-1; i++) {\n        for (int j = 0; j < n-i-1; j++) {\n            if (arr[j] > arr[j+1]) {\n                int temp = arr[j];\n                arr[j] = arr[j+1];\n                arr[j+1] = temp;\n            }\n        }\n    }\n}\n\nvoid printArray(int arr[], int size) {\n    for (int i = 0; i < size; i++)\n        cout << arr[i] << " ";\n    cout << endl;\n}\n\nint main() {\n    int arr[] = {64, 34, 25, 12, 22, 11, 90};\n    int n = sizeof(arr)/sizeof(arr[0]);\n    bubbleSort(arr, n);\n    cout << "Sorted array: \\n";\n    printArray(arr, n);\n    return 0;\n}',
      },
      {
        id: 113,
        name: "Selection Sort",
        slug: "selection-sort-cpp",
        language: "cpp",
        code: '// C++ program for Selection Sort\n#include <iostream>\nusing namespace std;\n\nvoid selectionSort(int arr[], int n) {\n    for (int i = 0; i < n-1; i++) {\n        int minIdx = i;\n        for (int j = i+1; j < n; j++) {\n            if (arr[j] < arr[minIdx])\n                minIdx = j;\n        }\n        swap(arr[minIdx], arr[i]);\n    }\n}\n\nvoid printArray(int arr[], int size) {\n    for (int i = 0; i < size; i++)\n        cout << arr[i] << " ";\n    cout << endl;\n}\n\nint main() {\n    int arr[] = {64, 25, 12, 22, 11};\n    int n = sizeof(arr)/sizeof(arr[0]);\n    selectionSort(arr, n);\n    cout << "Sorted array: \\n";\n    printArray(arr, n);\n    return 0;\n}',
      },
      {
        id: 114,
        name: "Insertion Sort",
        slug: "insertion-sort-cpp",
        language: "cpp",
        code: '// C++ program for Insertion Sort\n#include <iostream>\nusing namespace std;\n\nvoid insertionSort(int arr[], int n) {\n    for (int i = 1; i < n; i++) {\n        int key = arr[i];\n        int j = i - 1;\n        while (j >= 0 && arr[j] > key) {\n            arr[j + 1] = arr[j];\n            j = j - 1;\n        }\n        arr[j + 1] = key;\n    }\n}\n\nvoid printArray(int arr[], int size) {\n    for (int i = 0; i < size; i++)\n        cout << arr[i] << " ";\n    cout << endl;\n}\n\nint main() {\n    int arr[] = {12, 11, 13, 5, 6};\n    int n = sizeof(arr)/sizeof(arr[0]);\n    insertionSort(arr, n);\n    cout << "Sorted array: \\n";\n    printArray(arr, n);\n    return 0;\n}',
      },
      {
        id: 115,
        name: "Merge Sort",
        slug: "merge-sort-cpp",
        language: "cpp",
        code: '// C++ program for Merge Sort\n#include <iostream>\nusing namespace std;\n\nvoid merge(int arr[], int l, int m, int r) {\n    int n1 = m - l + 1;\n    int n2 = r - m;\n    int L[n1], R[n2];\n    for (int i = 0; i < n1; i++)\n        L[i] = arr[l + i];\n    for (int j = 0; j < n2; j++)\n        R[j] = arr[m + 1 + j];\n    int i = 0;\n    int j = 0;\n    int k = l;\n    while (i < n1 && j < n2) {\n        if (L[i] <= R[j]) {\n            arr[k] = L[i];\n            i++;\n        } else {\n            arr[k] = R[j];\n            j++;\n        }\n        k++;\n    }\n    while (i < n1) {\n        arr[k] = L[i];\n        i++;\n        k++;\n    }\n    while (j < n2) {\n        arr[k] = R[j];\n        j++;\n        k++;\n    }\n}\n\nvoid mergeSort(int arr[], int l, int r) {\n    if (l >= r)\n        return;\n    int m = l + (r - l) / 2;\n    mergeSort(arr, l, m);\n    mergeSort(arr, m + 1, r);\n    merge(arr, l, m, r);\n}\n\nvoid printArray(int arr[], int size) {\n    for (int i = 0; i < size; i++)\n        cout << arr[i] << " ";\n    cout << endl;\n}\n\nint main() {\n    int arr[] = {12, 11, 13, 5, 6, 7};\n    int arr_size = sizeof(arr) / sizeof(arr[0]);\n    cout << "Given array is \\n";\n    printArray(arr, arr_size);\n    mergeSort(arr, 0, arr_size - 1);\n    cout << "\\nSorted array is \\n";\n    printArray(arr, arr_size);\n    return 0;\n}',
      },
      {
        id: 116,
        name: "Quick Sort",
        slug: "quick-sort-cpp",
        language: "cpp",
        code: '// C++ program for Quick Sort\n#include <iostream>\nusing namespace std;\n\nvoid swap(int* a, int* b) {\n    int t = *a;\n    *a = *b;\n    *b = t;\n}\n\nint partition(int arr[], int low, int high) {\n    int pivot = arr[high];\n    int i = (low - 1);\n    for (int j = low; j <= high - 1; j++) {\n        if (arr[j] < pivot) {\n            i++;\n            swap(&arr[i], &arr[j]);\n        }\n    }\n    swap(&arr[i + 1], &arr[high]);\n    return (i + 1);\n}\n\nvoid quickSort(int arr[], int low, int high) {\n    if (low < high) {\n        int pi = partition(arr, low, high);\n        quickSort(arr, low, pi - 1);\n        quickSort(arr, pi + 1, high);\n    }\n}\n\nvoid printArray(int arr[], int size) {\n    for (int i = 0; i < size; i++)\n        cout << arr[i] << " ";\n    cout << endl;\n}\n\nint main() {\n    int arr[] = {10, 7, 8, 9, 1, 5};\n    int n = sizeof(arr) / sizeof(arr[0]);\n    quickSort(arr, 0, n - 1);\n    cout << "Sorted array: \\n";\n    printArray(arr, n);\n    return 0;\n}',
      },
      {
        id: 117,
        name: "Binary Search",
        slug: "binary-search-cpp",
        language: "cpp",
        code: '// C++ program for Binary Search\n#include <iostream>\nusing namespace std;\n\nint binarySearch(int arr[], int l, int r, int x) {\n    while (l <= r) {\n        int m = l + (r - l) / 2;\n        if (arr[m] == x)\n            return m;\n        if (arr[m] < x)\n            l = m + 1;\n        else\n            r = m - 1;\n    }\n    return -1;\n}\n\nint main() {\n    int arr[] = {2, 3, 4, 10, 40};\n    int n = sizeof(arr) / sizeof(arr[0]);\n    int x = 10;\n    int result = binarySearch(arr, 0, n - 1, x);\n    if (result == -1)\n        cout << "Element is not present in array";\n    else\n        cout << "Element is present at index " << result;\n    return 0;\n}',
      },
      {
        id: 118,
        name: "Depth First Search",
        slug: "dfs-cpp",
        language: "cpp",
        code: '// C++ program for Depth First Search\n#include <iostream>\n#include <list>\nusing namespace std;\n\nclass Graph {\n    int V;\n    list<int>* adj;\n    void DFSUtil(int v, bool visited[]);\n\npublic:\n    Graph(int V);\n    void addEdge(int v, int w);\n    void DFS(int v);\n};\n\nGraph::Graph(int V) {\n    this->V = V;\n    adj = new list<int>[V];\n}\n\nvoid Graph::addEdge(int v, int w) {\n    adj[v].push_back(w);\n}\n\nvoid Graph::DFSUtil(int v, bool visited[]) {\n    visited[v] = true;\n    cout << v << " ";\n    list<int>::iterator i;\n    for (i = adj[v].begin(); i != adj[v].end(); ++i)\n        if (!visited[*i])\n            DFSUtil(*i, visited);\n}\n\nvoid Graph::DFS(int v) {\n    bool* visited = new bool[V];\n    for (int i = 0; i < V; i++)\n        visited[i] = false;\n    DFSUtil(v, visited);\n}\n\nint main() {\n    Graph g(4);\n    g.addEdge(0, 1);\n    g.addEdge(0, 2);\n    g.addEdge(1, 2);\n    g.addEdge(2, 0);\n    g.addEdge(2, 3);\n    g.addEdge(3, 3);\n    cout << "Depth First Traversal (starting from vertex 2)" << endl;\n    g.DFS(2);\n    return 0;\n}',
      },
      {
        id: 119,
        name: "Breadth First Search",
        slug: "bfs-cpp",
        language: "cpp",
        code: '// C++ program for Breadth First Search\n#include <iostream>\n#include <list>\nusing namespace std;\n\nclass Graph {\n    int V;\n    list<int>* adj;\n\npublic:\n    Graph(int V);\n    void addEdge(int v, int w);\n    void BFS(int s);\n};\n\nGraph::Graph(int V) {\n    this->V = V;\n    adj = new list<int>[V];\n}\n\nvoid Graph::addEdge(int v, int w) {\n    adj[v].push_back(w);\n}\n\nvoid Graph::BFS(int s) {\n    bool* visited = new bool[V];\n    for (int i = 0; i < V; i++)\n        visited[i] = false;\n    list<int> queue;\n    visited[s] = true;\n    queue.push_back(s);\n    list<int>::iterator i;\n    while (!queue.empty()) {\n        s = queue.front();\n        cout << s << " ";\n        queue.pop_front();\n        for (i = adj[s].begin(); i != adj[s].end(); ++i) {\n            if (!visited[*i]) {\n                visited[*i] = true;\n                queue.push_back(*i);\n            }\n        }\n    }\n}\n\nint main() {\n    Graph g(4);\n    g.addEdge(0, 1);\n    g.addEdge(0, 2);\n    g.addEdge(1, 2);\n    g.addEdge(2, 0);\n    g.addEdge(2, 3);\n    g.addEdge(3, 3);\n    cout << "Breadth First Traversal (starting from vertex 2)" << endl;\n    g.BFS(2);\n    return 0;\n}',
      },
      {
        id: 120,
        name: "Dijkstra's Algorithm",
        slug: "dijkstra-cpp",
        language: "cpp",
        code: '// C++ program for Dijkstra\'s single source shortest path algorithm\n#include <iostream>\n#include <limits.h>\nusing namespace std;\n#define V 9\n\nint minDistance(int dist[], bool sptSet[]) {\n    int min = INT_MAX, min_index;\n    for (int v = 0; v < V; v++)\n        if (sptSet[v] == false && dist[v] <= min)\n            min = dist[v], min_index = v;\n    return min_index;\n}\n\nvoid printSolution(int dist[], int n) {\n    cout << "Vertex \\t Distance from Source\\n";\n    for (int i = 0; i < V; i++)\n        cout << i << " \\t\\t " << dist[i] << "\\n";\n}\n\nvoid dijkstra(int graph[V][V], int src) {\n    int dist[V];\n    bool sptSet[V];\n    for (int i = 0; i < V; i++)\n        dist[i] = INT_MAX, sptSet[i] = false;\n    dist[src] = 0;\n    for (int count = 0; count < V - 1; count++) {\n        int u = minDistance(dist, sptSet);\n        sptSet[u] = true;\n        for (int v = 0; v < V; v++)\n            if (!sptSet[v] && graph[u][v] && dist[u] != INT_MAX && dist[u] + graph[u][v] < dist[v])\n                dist[v] = dist[u] + graph[u][v];\n    }\n    printSolution(dist, V);\n}\n\nint main() {\n    int graph[V][V] = { {0, 1, 2, 0, 0, 0, 0, 0, 0}, {1, 0, 0, 1, 0, 0, 0, 0, 0}, {2, 0, 0, 2, 3, 0, 0, 0, 0}, {0, 1, 2, 0, 0, 1, 0, 0, 0}, {0, 0, 3, 0, 0, 1, 2, 3, 0}, {0, 0, 0, 1, 1, 0, 1, 0, 0}, {0, 0, 0, 0, 2, 1, 0, 1, 0}, {0, 0, 0, 0, 3, 0, 1, 0, 1}, {0, 0, 0, 0, 0, 0, 0, 1, 0} };\n    dijkstra(graph, 0);\n    return 0;\n}',
      },
      {
        id: 121,
        name: "Kruskals's Algorithm",
        slug: "kruskals-algorithm-cpp",
        language: "cpp",
        code: '// C++ program for Kruskal\'s algorithm\n#include <bits/stdc++.h>\nusing namespace std;\n\nclass Edge {\npublic:\n    int src, dest, weight;\n};\n\nclass Graph {\npublic:\n    int V, E;\n    Edge* edge;\n    Graph(int V, int E);\n    void addEdge(int u, int v, int w, int count);\n    void kruskalMST();\n};\n\nGraph::Graph(int V, int E) {\n    this->V = V;\n    this->E = E;\n    edge = new Edge[E];\n}\n\nvoid Graph::addEdge(int u, int v, int w, int count) {\n    edge[count].src = u;\n    edge[count].dest = v;\n    edge[count].weight = w;\n}\n\nclass subset {\npublic:\n    int parent;\n    int rank;\n};\n\nint find(subset subsets[], int i) {\n    if (subsets[i].parent != i)\n        subsets[i].parent = find(subsets, subsets[i].parent);\n    return subsets[i].parent;\n}\n\nvoid Union(subset subsets[], int x, int y) {\n    int xroot = find(subsets, x);\n    int yroot = find(subsets, y);\n    if (subsets[xroot].rank < subsets[yroot].rank)\n        subsets[xroot].parent = yroot;\n    else if (subsets[xroot].rank > subsets[yroot].rank)\n        subsets[yroot].parent = xroot;\n    else {\n        subsets[yroot].parent = xroot;\n        subsets[xroot].rank++;\n    }\n}\n\nint myComp(const void* a, const void* b) {\n    Edge* a1 = (Edge*)a;\n    Edge* b1 = (Edge*)b;\n    return a1->weight > b1->weight;\n}\n\nvoid Graph::kruskalMST() {\n    Edge result[V];\n    int e = 0;\n    int i = 0;\n    qsort(edge, E, sizeof(edge[0]), myComp);\n    subset* subsets = new subset[(V * sizeof(subset))];\n    for (int v = 0; v < V; ++v) {\n        subsets[v].parent = v;\n        subsets[v].rank = 0;\n    }\n    while (e < V - 1 && i < E) {\n        Edge next_edge = edge[i++];\n        int x = find(subsets, next_edge.src);\n        int y = find(subsets, next_edge.dest);\n        if (x != y) {\n            result[e++] = next_edge;\n            Union(subsets, x, y);\n        }\n    }\n    cout << "Following are the edges in the constructed MST\\n";\n    for (i = 0; i < e; ++i)\n        cout << result[i].src << " -- " << result[i].dest << " == " << result[i].weight << endl;\n    return;\n}\n\nint main() {\n    int V = 4;\n    int E = 5;\n    Graph g(V, E);\n    g.addEdge(0, 1, 10, 0);\n    g.addEdge(0, 2, 6, 1);\n    g.addEdge(0, 3, 5, 2);\n    g.addEdge(1, 3, 15, 3);\n    g.addEdge(2, 3, 4, 4);\n    g.kruskalMST();\n    return 0;\n}',
      },
    ],
  },
];

export default programNames;
